// Bypassing some lint conditions because this whole file really needs to be cleaned up
/*
 * Deprecating this functionality and no new functionality should be added to this file.
 * This file makes no sense, it's doing too many things.
 * TODO: Put these functionalities with their related files if needed, else delete them.
 */

import $ from 'jquery';

const _ = require('underscore');
const animations = require('../lib/sk-animations');
const reveal = require('../components/sk-reveal');
const sticky = require('../components/sk-sticky');

const ui = {
  pageAnchors() {
    const anchorLink = $('.anchor-link');

    // eslint-disable-next-line func-names
    anchorLink.on('click', function(e) {
      e.preventDefault();
      $('.anchor-link').removeClass('active');
      $(this).addClass('active');
      if (window.location.pathname === '/partners/portal/faq') {
        animations.easedAnchorScroll($(this), $($(this).attr('href')), 100, 0);
      } else {
        animations.easedAnchorScroll(
          $(this),
          $($(this).attr('href')),
          100,
          150
        );
      }
    });
  },

  pageAnchorToTop() {
    // TODO -- Make this so that the anchorlink appears appears relative to window height
    const anchorLinkToTop = $('.back-to-top');
    function checkAnchorLink() {
      anchorLinkToTop.toggleClass('off', $(window).scrollTop() < 768);
    }
    if (anchorLinkToTop.length) {
      anchorLinkToTop.addClass('off');
      $(window).scroll(_.throttle(checkAnchorLink, 250));
    }
  },

  reveal() {
    if ($('.reveal').length) {
      reveal.init();
    }
  },

  sticky() {
    if ($('#sk-sticky').length) {
      const pageSticky = $('#sk-sticky');

      if (pageSticky.length) {
        // eslint-disable-next-line no-inner-declarations
        function startStickyScroll() {
          sticky.pageScroll(pageSticky);
        }
        // eslint-disable-next-line no-inner-declarations
        function startStickyResize() {
          sticky.pageResize(pageSticky);
        }
        $(window).scroll(_.throttle(startStickyScroll, 150));
        $(window).resize(_.throttle(startStickyResize, 250));
      }
    } else if ($('#sk-sticky--full').length) {
      const pageSticky = $('#sk-sticky--full');

      if (pageSticky.length) {
        // eslint-disable-next-line no-inner-declarations
        function startStickyScroll() {
          sticky.pageScroll(pageSticky);
        }
        // eslint-disable-next-line no-inner-declarations
        function startStickyScrollMobile() {
          sticky.pageScrollMobile(pageSticky);
        }
        // eslint-disable-next-line no-inner-declarations
        function startStickyHideMobile() {
          sticky.pageHideMobile(pageSticky);
        }
        $(window).scroll(_.throttle(startStickyScroll, 150));
        $(window).scroll(_.throttle(startStickyScrollMobile, 150));
        $('#mobile-menu-toggle').click(startStickyHideMobile);
      }
    }
  }
};

const skUI = {
  init() {
    // TODO -- Remove this animation from login since only current login uses it.
    animations.wiggle();

    // TODO -- Add navigation to this
    ui.pageAnchors();
    ui.pageAnchorToTop();
    ui.reveal();
    ui.sticky();
  },

  // ** use $(window).on("load") instead of $(document).ready() so images
  // are loaded before element offset calculations are performed
  // if fromTop === false, scrolledBelowCall will fire when entire 'elems' object is in screen
  // offset can be a function that returns (will be called on window resize) or array
  onScrollBy: {
    desktopNavHeight: 70,
    mobileNavHeight: 51,

    init(
      elems,
      offset,
      fromTop,
      watchContinuous,
      scrolledBelowCall,
      scrolledAboveCall,
      passResizeHandler
    ) {
      const objTop = [];
      const objHeight = [];
      let objOffset = [];
      const scrolledBy = [].fill.call({ length: elems.length }, false);
      let scrollTo = [];
      let scrollLen = 0;
      let windowHeight = $(window).height();

      const calculateWindowHeight = () => {
        windowHeight = $(window).height();
      };
      // eslint-disable-next-line func-names
      const calculateObjInfo = function() {
        const windowWidth = $(window).width();
        let tempOffset;
        objOffset = [];

        if (typeof offset === 'function') {
          tempOffset = offset();
        } else {
          tempOffset = offset;
        }
        if (typeof tempOffset === 'object') {
          if (tempOffset[0].mobile) {
            _.each(tempOffset, (item) => {
              if (windowWidth >= item.breakpoint) {
                objOffset.push(item.desktop);
              } else {
                objOffset.push(item.mobile);
              }
            });
          } else {
            objOffset = tempOffset;
          }
        } else {
          objOffset.push(tempOffset);
        }
        // eslint-disable-next-line func-names
        elems.each(function(index) {
          objTop[index] =
            $(this).offset().top + (objOffset[index] || objOffset[0]);
          objHeight[index] = $(this).outerHeight();
        });
        scrollTo = objTop;
        scrollLen = scrollTo.length - 1;

        if (!fromTop) {
          scrollTo = scrollTo.map((num, index) => {
            return num + objHeight[index] - windowHeight;
          });
        }
      };
      calculateWindowHeight();
      calculateObjInfo();

      const scrollHandler = () => {
        const scrollPosition = $(window).scrollTop();

        _.each(scrollTo, (num, index) => {
          if (scrollPosition >= num && !scrolledBy[index]) {
            scrolledBy[index] = true;

            if (scrolledBelowCall) {
              scrolledBelowCall(elems[index], index, elems);
            }
            if (!watchContinuous) {
              $(window).off('scroll', scrollHandler);
              // eslint-disable-next-line no-use-before-define
              $(window).off('resize', resizeHandler);
            }
          } else if (
            watchContinuous &&
            scrollPosition < scrollTo[scrollLen - index] &&
            scrolledBy[scrollLen - index]
          ) {
            scrolledBy[scrollLen - index] = false;

            if (scrolledAboveCall) {
              scrolledAboveCall(
                elems[scrollLen - index],
                scrollLen - index,
                elems
              );
            }
          }
        });
      };
      const resizeHandler = () => {
        calculateWindowHeight();

        if ($(elems[0]).css('position') !== 'fixed') {
          calculateObjInfo();
        }
      };
      if (passResizeHandler) {
        passResizeHandler(resizeHandler);
      }
      if (watchContinuous) {
        scrollHandler();
      }
      $(window).resize(resizeHandler);
      $(window).scroll(scrollHandler);
    },
    watch(elems, offset, scrolledBelowCall, scrolledAboveCall) {
      this.init(
        elems,
        offset,
        true,
        true,
        scrolledBelowCall,
        scrolledAboveCall
      );
    }
  }
};

export default skUI;
